var map = {
	"./loader_with_primary_background_animation": 28239,
	"./loader_with_primary_background_animation.json": 28239,
	"./loaders": 20580,
	"./loaders.json": 20580,
	"./spinner-middle-gray": 37249,
	"./spinner-middle-gray.json": 37249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66939;